import FileDropZoneWrapper from './FileDropZoneWrapper';

export default FileDropZoneWrapper;
